import { USER_LOGGED_OUT } from './constants';
import { getPublicIP, getAuthHeader } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse , loader } from './utils';
import { removeSessionData } from "../helpers/authHelper";

export const logoutUser = () => {
  removeSessionData();
  return {
    type: USER_LOGGED_OUT
  };
};
export const createLogoutRequest = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    //bodyFormData.set('user_id', login.user.id);
    bodyFormData.set('device_token', getPublicIP());
    bodyFormData.set('device_type', 'WEB');
    const headers = getAuthHeader();
    
    postReq(`${apiURLPrefix}/user/user_logout`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(logoutUser())
    }).catch((err)=>{
      console.log(err)
    }) 
  }
};